import React, { useEffect, useLayoutEffect } from 'react';
import * as Sentry from '@sentry/react';
import { start } from '@zhipu/zprep';
import _ from 'lodash';
import { isBrowser } from 'umi';

import { getUrlParams } from './utils/';
import { updateStatus } from './utils/line';

if (
  isBrowser() &&
  process.env.NODE_ENV === 'production' &&
  window.location.host === 'vip.aminer.cn'
) {
  Sentry.init({
    dsn: 'https://2fa7b6220d8c3f6c9fbbed9f06838690@analysis.aminer.cn/sentry/2',
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ['localhost', /^https:\/\/vip\.aminer\.cn\/analysis/],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    beforeSend(event, hint) {
      // 检查是否存在异常（exception）
      if (hint && hint.originalException) {
        const error: any = hint.originalException;
        // 如果是接口错误，可以附加额外信息
        if (error && error.response) {
          event.extra = {
            ...(event?.extra || {}),
            request: {
              url: error.config?.url, // 请求 URL
              method: error.config?.method, // 请求方法
              data: error.config?.data, // 请求数据
              headers: error.config?.headers, // 请求头
            },
            response: {
              status: error.response?.status, // 响应状态码
              data: error.response?.data, // 响应数据
            },
          };
        }
      }
      return event; // 返回修改后的事件
    },
  });
}

//  用于处理 ssr 警告
React.useLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;

export const dva = {
  config: {
    onError(e: { preventDefault: () => void; statusCode: any }) {
      e.preventDefault();
      console.log('dvaError', e.statusCode);
    },
  },
};

export const qiankun = {
  // 应用加载之前
  async bootstrap(props) {
    console.log('app1 bootstrap', props);
  },
  // 应用 render 之前触发
  async mount(props) {
    console.log('app1 mount', props);
  },
  // 应用卸载之后触发
  async unmount(props) {
    console.log('app1 unmount', props);
  },
};

// 服务端不渲染
if (isBrowser && isBrowser()) {
  start({
    //  初始化监控
    bid: 1067,
    secret:
      'Bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJhaWQiOiI2MjE4OTk3MzMyYWZlYWU0ZWI1ODgzYjYiLCJhdWQiOlsiMjhkYzg4ZGEtYmE1Yi00Zjc0LTg0MDAtZGMwMmU3MmEyMDk5Il0sImNpZCI6IjI4ZGM4OGRhLWJhNWItNGY3NC04NDAwLWRjMDJlNzJhMjA5OSIsImV4cCI6MTY4MTIwMjMzOCwiZ2VuZGVyIjowLCJpYXQiOjE2ODExOTg3MzgsImlkIjoiNjIxODk5NzMzMmFmZWFlNGViNTg4M2I2IiwiaXNzIjoib2F1dGguYW1pbmVyLmNuIiwianRpIjoiZWNmMmI1ZjQtZWU1ZC00MWVmLTlhNzQtZmVjNmZhNjNkNzMzIiwibmJmIjoxNjgxMTk4NzM4LCJuaWNrbmFtZSI6IlpISVlJTmFkbWluIiwic3ViIjoiNjIxODk5NzMzMmFmZWFlNGViNTg4M2I2IiwidCI6IlBhc3N3b3JkIn0.oRuMo-deDhrrKKaQnnCrA34HHMexQOPsGCF6MtTENTwAplVkeb9rsJPAU-3dLz-yQ1OAPfMkrQyDa-0PiLq7fX_xSxSIDK_q09-NGxiP1v3WWdodBXYIfpQF8bWyuuQbSUj8RFNolPjc8hDI4oOSRbgQEFO8ITo_-9pVchT3LlggMQYrkoVpIqe-j0381YOtFtc3q6X88cX1XdrRDp3u3_E73KMiT-sl--KANT2daaTjG0gNHoEJGG2j4d7DSSCGh03kaPgZc98AvAD3vjOIY9w7rGnT5GMKTeNGbxwJAO-X26fFNB00NTYrSLx6vnUndFaP4w9b_RiFSNPhwQ6AmQ',
    inside: false,
  });
  const windowOpen = window.open;
  window.open = function (href, ...arg) {
    const [pathname, search] = href.split('?');
    let url = '';
    if (pathname.includes('/list')) {
      const query = getUrlParams(href);
      const curQuery = getUrlParams(window.location.href);
      const mergeQuery = {
        ...curQuery,
        ...query,
      };
      const queryArray = Object.entries(mergeQuery).map(([key, value]) => {
        return `${key}=${value}`;
      });
      const queryString = queryArray.join('&');
      url = pathname + '?' + queryString;
      // windowOpen(pathname + '?' + queryString, ...arg);
    } else {
      url = href;
      // windowOpen(href, ...arg);
    }
    windowOpen(
      PUBLICKPATH === 'aminerzhiyin' ? url.replace('aminerzhiyin', 'analysis') : url,
      ...arg,
    );
  };
}

if (isBrowser?.()) {
  // 页面加载完成后，更新网络状态
  window.onload = function () {
    updateStatus();
    // 监听网络状态变化
    window.addEventListener('online', updateStatus);
    window.addEventListener('offline', updateStatus);
  };
}
